module.exports = __webpack_public_path__ + "files/0a355eb295e303c7614ff8eefbafe280.png";